import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { OverlayDelay } from "react-bootstrap/esm/OverlayTrigger";
import { Placement } from "react-bootstrap/esm/types";

type ZTooltipProps = {
  placement?: Placement;
  delay?: OverlayDelay;
  text?: string;
  style?: React.CSSProperties;
  tooltipClassName?: string;
  enabled?: boolean;
  className?: string;
  children: React.ReactElement;
};

export function ZTooltip({
  placement,
  delay,
  text,
  style,
  tooltipClassName,
  enabled = true,
  className,
  children,
}: ZTooltipProps) {
  return (
    <OverlayTrigger
      placement={placement}
      delay={delay ?? { show: 300, hide: 0 }}
      // Always render the same overlay structure.
      overlay={
        enabled ? (
          <Tooltip
            id="tooltip"
            className={`tooltip ${tooltipClassName}`}
            style={{
              zIndex: 100000,
              marginTop: -700,
              whiteSpace: "pre-wrap",
              pointerEvents: "none",
              ...style,
            }}
          >
            {text}
          </Tooltip>
        ) : (
          // Render an empty fragment if tooltip is disabled.
          <></>
        )
      }
    >
      {/* Always render the same child container so focus isn’t lost */}
      <div className={className ?? "d-flex"}>{children}</div>
    </OverlayTrigger>
  );
}
